var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval62B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M0 35c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 49 0 42.732 0 35ZM35.224 60.83a2.5 2.5 0 0 1-2.488 2.253h-5.471a2.5 2.5 0 0 1-2.488-2.253l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M33.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C36.026 63.252 34.706 64 33.262 64h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18.224 60.83a2.5 2.5 0 0 1-2.488 2.253h-5.471a2.5 2.5 0 0 1-2.488-2.253l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M16.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C19.026 63.252 17.706 64 16.262 64H9.738c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M52.224 60.83a2.5 2.5 0 0 1-2.488 2.253h-5.471a2.5 2.5 0 0 1-2.488-2.253l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M50.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C53.026 63.252 51.706 64 50.262 64h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20.666 13.5a2.5 2.5 0 0 1-2.5 2.5H6.5A2.5 2.5 0 0 1 4 13.5v-10A2.5 2.5 0 0 1 6.5 1h14.166v12.5ZM38.334 13.5a2.5 2.5 0 0 1-2.5 2.5H24.166a2.5 2.5 0 0 1-2.5-2.5V1h16.666v12.5ZM56 13.5a2.5 2.5 0 0 1-2.5 2.5H41.833a2.5 2.5 0 0 1-2.5-2.5V1H53.5A2.5 2.5 0 0 1 56 3.5v10Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M4 12a1 1 0 0 1-1-1V3.5A3.5 3.5 0 0 1 6.5 0h47A3.5 3.5 0 0 1 57 3.5V11a1 1 0 1 1-2 0V3.5A1.5 1.5 0 0 0 53.5 2h-47A1.5 1.5 0 0 0 5 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgOval62B.viewBox = '0 0 60 64';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval62B);
export default ForwardRef;